<template>
  <article class="user_view">
    <left-menu/>
    <section class="user_view__header">
      <div class="user_view__header--info"> 
        <div>
          <h1>Administradores</h1>
          <h4>Listado de administradores registrados</h4>
        </div>
      </div>
      <div class="user_view__header--sec1">
        <button  class="secondary_button" :class="{'click':isUpdate, 'active': !isUpdate}" @click="toUpdate" >ACTUALIZAR</button>
        <button v-if="getRol() == 'admin'" class="primary_button" @click="$router.push({ name: 'CreateAdmin' })" >CREAR</button>
      </div>
      <info-table :name="'administradores'" :columns="columns" :items.sync="admins" :actions="true"/>

      <div class="info_table__foot">
              <div/>
              <div class="paginator">
                {{shownItemsFrom}} - {{shownItemsTo}} 
                <div class="paginator__numbers">
                  <div v-for="(page,i) in total_pages" @click="handlePageChange(i+1)" :key=i class="paginator__numbers--num" :class="{'active': currentPage==i+1}">
                    {{i+1}}
                  </div>
                  <div class="paginator__numbers--num" @click="handlePageChange(currentPage+1)">
                    >
                  </div>
                </div>
              </div>
      </div>

    </section>
  </article>
</template>

<script>
import Table from './../shared/Table';
export default {
  data(){
    return{
      columns:[
        {
          name: 'Cedula',
          sortable: true,
        },
        {
          name: 'Nombre',
          sortable: true,
        },
        {
          name: 'Rol',
          sortable: true,
        },
        {
          name: 'Acciones',
          enabled: true,
        },
        
      ],

      mockedAdmins:[
        {
          user:{
            card_company: 2893049,
            name: 'Mario José',
            last_name: 'Díaz Martínez',
            id_card: '1098765375',
          },
          
        },
        {
          user:{
            card_company: 456456,
            name: 'Juan Pablo',
            last_name: 'Díaz Martínez',
            id_card: '1098765343',
          },
          
        }
      ],
      isUpdate:false,
      admins:[],
      total_pages: 0,
      currentPage: 1,
      shownItemsFrom:0,
      shownItemsTo: 12,
      maxPage:12,
    }
  },
  components:{
      'info-table':Table, 
  },
  methods:{

    handlePageChange(value) {
      this.currentPage = value;
      this.toUpdate()
    },

    toUpdate(){
      this.isUpdate=true;  
      setTimeout(() => { this.isUpdate=false; }, 200);  
      
      const customActions={
          get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
      };
      var card=JSON.parse(localStorage.getItem("user")).id_card; 
      this.$resource('administrators/dashboard'+ '?page=' + this.currentPage,{},customActions).get({id_card:card})
      .then(function(data){
        this.total_pages = data.body.total_pages
        this.admins=data.body.data;
      });
    }
  },
  created(){
    this.toUpdate()
    // const customActions={
    //     get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
    // };
    // var card=JSON.parse(localStorage.getItem("user")).id_card; 
    // this.$resource('administrators/dashboard',{},customActions).get({id_card:card})
    // .then(function(data){
    //   this.admins=data.body;
      
    // });
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Admins.vue